import { render, staticRenderFns } from "./LotCollectionInformation.vue?vue&type=template&id=3ce65398&scoped=true"
import script from "./LotCollectionInformation.vue?vue&type=script&lang=js"
export * from "./LotCollectionInformation.vue?vue&type=script&lang=js"
import style0 from "./LotCollectionInformation.vue?vue&type=style&index=0&id=3ce65398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce65398",
  null
  
)

export default component.exports